





import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {ActiveProvide} from "@/support/reactive"

@Component
export default class JdsListLayout extends Vue {

    @ActiveProvide('jds.list-item.sortable') sortableChildren = false;
    @Prop({default: false, type: Boolean}) sortable!: boolean;

    @Watch('sortable', {immediate: true})
    sync() {
        this.sortableChildren = this.sortable;
    }

}
